import * as React from "react";
import { Outlet, useParams } from "react-router-dom";
import { DASHBOARD, SURVEY, MESSAGE } from "icons";
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarMenu,
  SidebarProvider,
  SidebarRail,
} from "ui/components/sidebar";
import Loader from "@/components/loader";
import { NavItem } from "@/components/nav/item";
import { useFetch } from "@/hooks/useFetch";
import { PAGE_BANNER_PORTAL_ID } from "utils";
import { fetchClientDetails } from "./api";

export default function ClientLayout(props) {
  const { clientId } = useParams();
  const { data: client, isLoading } = useFetch({
    queryKey: ["client-details", clientId],
    queryFn: () => fetchClientDetails({ clientId }),
  });

  if (isLoading) return <Loader />;
  if (!client) return null;

  return (
    <div className="flex-1 flex flex-col relative min-w-0 h-full">
      <div className="flex flex-1 relative min-w-0 overflow-hidden">
        <SidebarProvider className="w-fit overflow-hidden h-full" name="client">
          <Sidebar
            collapsible="icon"
            {...props}
            className="sidebar-height border-r left-auto inset-y-auto top-0 mt-16"
          >
            <SidebarContent>
              <SidebarGroup>
                <SidebarMenu>
                  <NavItem
                    title="Dashboard"
                    icon={DASHBOARD}
                    url={`/crm/clients/${clientId}`}
                    matchExact={true}
                  />
                  <NavItem
                    title="Surveys"
                    icon={SURVEY}
                    url={`/crm/clients/${clientId}/surveys`}
                  />
                  <NavItem
                    title="Testimonials"
                    icon={MESSAGE}
                    url={`/crm/clients/${clientId}/testimonials`}
                  />
                </SidebarMenu>
              </SidebarGroup>
            </SidebarContent>
            <SidebarRail />
          </Sidebar>
        </SidebarProvider>
        <div className="flex flex-1 flex-col min-w-0">
          <div
            id={PAGE_BANNER_PORTAL_ID}
            className="flex flex-col gap-2 px-4 pt-4 empty:hidden"
          />
          <Outlet />
        </div>
      </div>
    </div>
  );
}
